export const RECALCULATE_CONFIRMATION_MESSAGE = 'Atenção: Lançamentos conciliados no financeiro também serão excluídos.';
export const RECALCULATE_BOX_INFORMATION = {
  theme: 'warning',
  title: 'Atenção com as transmissões para o financeiro',
  message: 'Ao recalcular, caso existam lançamentos conciliados, estes serão substituídos.',
};
